import React from "react";
import { ISchemaKey } from "helpers/product-collection";
import { IValueTypeMap } from "./types";
import { useFetchSchemaLookup } from "./hooks";

interface ILookupFieldsProps {
    schema: ISchemaKey;
    dependenciesValues: IValueTypeMap;
    merchantId: string;
    positionIndex: number;
    fieldRenderer: (text: string, index: number) => JSX.Element;
}

export interface LookUpFieldMap {
    [targetId: string]: {
        schemaList: ISchemaKey[];
        dependenciesValues: IValueTypeMap;
    };
}

export const LookupField = (props: ILookupFieldsProps) => {
    const { schema, dependenciesValues, merchantId, fieldRenderer, positionIndex } = props;
    const { rows } = useFetchSchemaLookup(schema, dependenciesValues, merchantId);
    const fieldValue = dependenciesValues[schema.field_name]?.value;

    const value = React.useMemo(() => {
        const rawValue = fieldValue;

        if (!String(rawValue ?? "").trim()) {
            return "";
        }

        const row = rows.find((row) => row.value.raw === rawValue);

        return row ? row.value.dropdownFormatted : rawValue;
    }, [rows, fieldValue]);

    return fieldRenderer(value, positionIndex);
};

interface ISingleLineLookupFieldsProps {
    schemaList: ISchemaKey[];
    dependenciesValues: IValueTypeMap;
    merchantId: string;
    fieldRenderer: (text: string, index: number) => JSX.Element;
}
export const SingleLineLookupFields = (props: ISingleLineLookupFieldsProps) => {
    const { schemaList, dependenciesValues, merchantId, fieldRenderer } = props;
    return (
        <>
            {schemaList.map((schema, index) => (
                <LookupField
                    key={index}
                    fieldRenderer={fieldRenderer}
                    schema={schema}
                    dependenciesValues={dependenciesValues}
                    merchantId={merchantId}
                    positionIndex={index}
                />
            ))}
        </>
    );
};
